import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./router/routes";

const App: React.FC = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes/>
      </BrowserRouter>
    </div>
  );
};

export default App;
